<input 
    type="checkbox"
    appFormCheckField
    [id]="id()"
    [name]="name()"
    [checked]="checked()"
    [disabled]="frazzled()"
    [indeterminate]="indeterminate()"
    (onChange)="onChangeHandler($event)"
    style="width: 18px; height: 18px;"
/>